import React from "react";
import { string, array, func } from "prop-types";

import "./Tabs.css";

const Tabs = ({ selectedTab, tabs, onTabClick }) => {
  return (
    <div className="tabs">
      {tabs.map((tab, index) => {
        const isSelected = selectedTab === tab;
        return (
          <button
            key={tab}
            className={isSelected ? "tab selected" : "tab"}
            onClick={() => {
              onTabClick(tab);
            }}
          >
            {tab}
          </button>
        );
      })}
    </div>
  );
};

Tabs.propTypes = {
  selectedTab: string,
  tabs: array,
  onTabClick: func
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/common/tabs/Tabs.js